import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { AnswerGeneratedButtons } from './answer-generated.interface';
import { inputSubtext } from '../chat-container/constants';

@Component({
    selector: 'mapp-answer-generated',
    templateUrl: './answer-generated.component.html',
    styleUrls: ['./answer-generated.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AnswerGeneratedComponent {
    readonly DEFAULT_LEGAL_DISCLAIMER = inputSubtext;

    @Input() title = 'Your answer have been generated.';

    @Input() subtitle =
        'Download the generated file below. If needed, try again with the files you previously uploaded, or start over to begin a new process.';

    @Input() buttons: AnswerGeneratedButtons;
}
